import SearchBar from "../Reusables/SearchBar";

export const StudentFilter2 = ({ setSearchTerm }: any) => {
  return (
    <div
      className="flex flex-wrap justify-start mr-6 md:justify-between
    text-[#1f1f1f]/[0.7] md:mt-6 mb-3 w-[98%] "
    >
      <div className="flex items-center w-full max-w-[240px] min-w-max">
        <></>
        <></>
      </div>
      <div className="w-4/12 min-w-max mt-6 md:mt-0">
        <SearchBar onChange={(e: any) => setSearchTerm(e.target.value)} />
      </div>
    </div>
  );
};
